<template>
  <div class="tabBox">
    <el-table :data="tableData" style="width: 100%;text-align: center;" highlight-current-row @current-change='currentChange'>
      <el-table-column prop="title" align="center" label="名称">
      </el-table-column>
      <el-table-column prop="orgName" align="center" label="上传机构">
      </el-table-column>
      <el-table-column prop="createtime" align="center" label="上传时间">
      </el-table-column>
      <el-table-column prop="fileDes" align="center" label="描述">
      </el-table-column> 
      <el-table-column align="center" label="文件">
        <template slot-scope="scope">
          <a href="javascript:(0)" style="color:#1f2d3d;text-decoration: underline;" @click='download(scope.row.id)'>{{scope.row.fileName}}</a>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import burst from '@/data/basic/manage/guidefile'
export default {
  data() {
    return {
      tableData: []
    }
  },
  created() {
    this.get_burst_list()
  },
  methods: {
    get_burst_list() {
      (async() => {
        let data = await burst.burst_list({
          categories: 3
        })
        if (data) {
          this.tableData = data
        } else {
          this.$message({
            message: '列表获取失败',
            type: 'warning'
          });
        }
      })()
    },
    download(id) {
      if (!id) {
        this.$message({
          message: '文件获取失败,请稍候重试',
          type: 'warning'
        });
        return
      }
      window.location.href = `/api/emer/file/guidance/download?id=${id}`
    },
    currentChange(row) {
      let currId = row ? row.id : null
      this.$emit('currentChange', currId)
    }
  }
}

</script>
<style>


</style>



// WEBPACK FOOTER //
// bursttab.vue?29397e56